<div class="mx-5 my-5 px-5 py-5">
    <div id="card-filter-info" class="mt-4 mb-4">
        <mat-card>
            <div class="row">
                <div class="col-sm-1">
                    <label>Ano</label>
                    <input type="number" class="form-control" name="year" [(ngModel)]="subaccountSelected" />
                </div>
                <div class="col-sm-1">
                    <br />
                    <button
                        mat-raised-button
                        matTooltip="Buscar Todas Entidades"
                        matTooltipClass="text-light bg-dark"
                        class="mr-3"
                        color="primary"
                        (click)="searchAllEntities()"
                        [disabled]="_loaderService.isLoading | async">
                        <mat-icon>search</mat-icon>
                        Tudo
                    </button>
                </div>

                <div class="col-sm-2">
                    <br />
                    <button
                        mat-raised-button
                        matTooltip="Buscar Todas Escolas"
                        matTooltipClass="text-light bg-dark"
                        class="mr-3"
                        color="primary"
                        (click)="searchAllEntitiesChield()"
                        [disabled]="_loaderService.isLoading | async">
                        <mat-icon>search</mat-icon>
                        Buscar Escolas (Filhas)
                    </button>
                </div>
            </div>
        </mat-card>

        <mat-card>
            <mat-card-title class="justify-content-center">
                <span class="text-muted"> {{ sessionBusiness.EntityDescriptionContext }}</span>
            </mat-card-title>
            <mat-card-subtitle>
                <label>Mapeamentos de :</label>
            </mat-card-subtitle>

            <mat-card-content>
                <div class="buttonFilter">
                    <div class="row">
                        <div class="col-sm-1">
                            <mat-form-field style="width: 100%" id="datepickerYear" appearance="fill">
                                <mat-label> {{ 'DATEPICKER.Year' | translate }} </mat-label>
                                <input matInput [matDatepicker]="dp" [formControl]="yearSelected" />
                                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                                <mat-datepicker
                                    #dp
                                    startView="multi-year"
                                    (yearSelected)="chosenYearHandler($event, dp)"
                                    panelClass="example-month-picker">
                                </mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-2">
                            <mat-form-field style="width: 100%" appearance="fill" [floatLabel]="'auto'">
                                <mat-label> {{ 'BILLET.period' | translate }} </mat-label>
                                <mat-select
                                    [disabled]="_loaderService.isLoading | async"
                                    [(value)]="periodSelected.periodId"
                                    (valueChange)="onPeriodChange($event)">
                                    <mat-option *ngFor="let period of periodList" [value]="period.periodId">
                                        {{ period.description }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-3">
                            <mat-form-field style="width: 100%" appearance="fill" [floatLabel]="'auto'">
                                <mat-label> Level </mat-label>
                                <mat-select
                                    [disabled]="_loaderService.isLoading | async"
                                    [(value)]="levelSelected.levelId"
                                    (valueChange)="onLevelChange($event)">
                                    <mat-option *ngFor="let level of levelList" [value]="level.levelId">
                                        {{ level.description }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-3">
                            <button
                                mat-raised-button
                                matTooltip="Limpar"
                                matTooltipClass="text-light bg-dark"
                                class="mr-3"
                                (click)="onClear()"
                                [disabled]="_loaderService.isLoading | async">
                                <mat-icon>clear</mat-icon>
                                {{ 'ACTION.Clear' | translate }}
                                <label [hidden]="!contractList.length"> ({{ contractList?.length }}) </label>
                            </button>
                            <button
                                mat-raised-button
                                color="primary"
                                (click)="onSearch(false, false)"
                                [disabled]="_loaderService.isLoading | async">
                                <mat-icon>search</mat-icon> {{ 'ACTION.Search' | translate }}
                            </button>

                            
                        </div>
                        <div class="col-sm-1">
                            <div class="form-check">
                                <input
                                    [disabled]="_loaderService.isLoading | async"
                                    class="form-check-input"
                                    (change)="clearResult()"
                                    [(ngModel)]="mappType"
                                    [value]="MappingType.Novo"
                                    type="radio"
                                    checked="true"
                                    name="mapType"
                                    id="typeNew" />
                                <label class="form-check-label" for="typeNew"> Novo </label>
                            </div>
                            <div class="form-check">
                                <input
                                    [disabled]="_loaderService.isLoading | async"
                                    class="form-check-input"
                                    [(ngModel)]="mappType"
                                    (change)="clearResult()"
                                    [value]="MappingType.Antigo"
                                    type="radio"
                                    name="mapType"
                                    id="typeOld" />
                                <label class="form-check-label" for="typeOld"> Antigo </label>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-check" (click)="onChangeRadio(checkEnum.all)">
                                <input
                                    [disabled]="_loaderService.isLoading | async"
                                    class="form-check-input"
                                    (change)="clearResult()"
                                    type="radio"
                                    name="radioMapp"
                                    id="radioAll" />
                                <label class="form-check-label" for="radioAll"> Todos </label>
                            </div>
                            <div class="form-check" (click)="onChangeRadio(checkEnum.onlyMapp)">
                                <input
                                    [disabled]="_loaderService.isLoading | async"
                                    class="form-check-input"
                                    type="radio"
                                    (change)="clearResult()"
                                    name="radioMapp"
                                    id="onlyMapp" />
                                <label class="form-check-label" for="onlyMapp"> Somente Mapeados </label>
                            </div>
                            <div class="form-check" (click)="onChangeRadio(checkEnum.notMapp)">
                                <input
                                    [disabled]="_loaderService.isLoading | async"
                                    class="form-check-input"
                                    type="radio"
                                    (change)="clearResult()"
                                    name="radioMapp"
                                    id="notMapp"
                                    checked />
                                <label class="form-check-label" for="notMapp"> Não Mapeados </label>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <loader></loader>

    <mappingCurrentAccountBillet-listContract
        [mappType]="mappType"
        [isLoading]="isLoading"
        [filterTable]="filterTable"
        [contractList]="contractList"
        [contractListSorted]="contractList">
    </mappingCurrentAccountBillet-listContract>
</div>
